import styled from 'styled-components'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const DataWrapper = styled('div')`
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin-bottom: 20px;
  }

  @media (min-width: 1024px) {
    width: 50%;
    margin-bottom: 0px;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    width: 70%;
  }
`

export const DataCol = styled('div')`
  width: 75%;
  overflow: hidden;
  padding-right: 20px;
`

export const Heading = styled('div')`
  width: 100%;
  * {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`

export const Logo = styled('img')`
  max-width: 90px;
  height: 57px;
  background: white;
  margin-right: 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grey24};

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin-right: 16px;
  }
`

export const CompanyLink = styled(Link)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
  padding: 0px;
  border: 0px;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }

  &[disabled] {
    cursor: default;
  }

  :hover .company-verified i:before {
    background-color: ${({ theme }) => theme.colors.info.normal} !important;
  }
`

export const ContainerLink = styled.div`
  display: flex;
  align-items: center;
`

export const Company = styled('div')`
  margin-left: 6px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const DataContainer = styled('div')`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 12px;
`

export const RatingContainer = styled(DataContainer)`
  align-items: center;
  gap: 4px;
`

export const LogoImage = styled.img`
  width: 30px;
  height: 51px;
`

export const ContainerAltaRevision = styled.div`
  display: flex;
  align-items: center;
`

export const NameContainer = styled.div`
  display: flex;
  align-items: baseline;
  max-width: 100%;
`

export const LogosContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-right: 12px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin-right: 16px;
  }
`
